module.exports = __webpack_public_path__ + "static/logo3-b6051290a5aaf8656e5b09f4f08bb937.png";